












import { defineComponent, ref } from '@vue/composition-api';
import { openWebPage } from '@/utils/openWebPage';
import { getJumpAppVersion } from '@/utils/jumpAppInfo';

const PRODUCT_FUNCTION_URL = 'https://www.daxuesoutijiang.com/dx-h5/appdownload.html?showOpenButton=0';
const PRIVACY_POLICY_URL = 'https://www.daxuesoutijiang.com/static/hy/dx-app/privacyProtocol.html';
const PERMISSION_URL = 'https://gth5.zuoyebang.com/perform/privacy/college-authority-detail';

export default defineComponent({
  name: 'ComplianceFooter',
  setup(props, { root }) {
    const appVersion = ref('');
    getJumpAppVersion(root.$http, 'college').then(version => {
      appVersion.value = version;
    });

    const onProductFunctionClick = () => {
      openWebPage(PRODUCT_FUNCTION_URL);
    };
    const onPrivacyPolicyClick = () => {
      openWebPage(PRIVACY_POLICY_URL);
    };
    const onPermissionClick = () => {
      openWebPage(PERMISSION_URL);
    };

    return { appVersion, onProductFunctionClick, onPrivacyPolicyClick, onPermissionClick };
  }
});
